import React,{ useState, useEffect } from 'react';
import axios from 'axios';
import { useAppConfig } from '../../AppConfigProvider';
const Count = ({id}) => {
  const appConfig = useAppConfig();
    const [count, setCount] = useState(null);
    useEffect(() => {
        const fetchCount = async () => {
            await axios.get(`${appConfig.backendUrl}api/v1/bill/DocsCount/${id}`).then(function(response){
                setCount(response.data);
              });
        }
        fetchCount();
    }, [appConfig.backendUrl, id]);
  return (
    <div>{count}</div>
  )
}

export default Count